// client/src/api/superAdmin.js
import api from "./config.js";

// Login de SuperAdmin
export const loginSuperAdmin = async (credentials) => {
  const { data } = await api.post("/superadmin/login", credentials);
  return data; // { token, superAdmin }
};

// Obtener todos los super admins
export const getSuperAdmins = async () => {
  const { data } = await api.get("/superadmin");
  return data;
};

// Crear super admin
export const createSuperAdmin = async (superAdmin) => {
  const { data } = await api.post("/superadmin", superAdmin);
  return data;
};
